<template>
    <div class="blog-section">
        <div class="container">
            <!-- <h1 class="text-center title is-size-3 mb-5">Blog Post</h1> -->
            <div class="blog-posts pt-5">
                <div class="columns">
                  <div v-for="post in posts" :key="post.id" class="column">
                      <div class="px-2 content">
                        <div v-if="post._links['wp:featuredmedia']" class="blog-image-wrapper" >
                          <a :href="post.link">
                            <blog-image
                                :url="post._links['wp:featuredmedia'][0].href">
                            </blog-image>
                          </a>
                        </div>
                        <div class="blog-content">
                          <a class="blog-title mb-2 d-block" :href="post.link">{{ post.title.rendered }}</a>
                          <div class="blog-description">{{ stripTags(post.content.rendered) }}</div>
                          <div>
                            <a :href="post.link" class="has-text-primary mt-4">READ MORE</a>
                          </div>
                        </div>
                      </div>
                  </div>
                </div>
            </div>

            <p class="subtitle text-center is-size-4 mt-5 mb-1">
               Find Latest News, Updates and <a href="https://blog.bimafy.com">Much More </a>
            </p>

        </div> <!-- end container -->
    </div> <!-- end blog-section -->
</template>

<script>
import BlogImage from './BlogImage'
import sanitizeHtml from 'sanitize-html'

export default {
    components: {
        BlogImage,
    },
    created() {
      console.log('created`')
          // var blog_post_url = 'https://blog.bimafy.com/wp-json/wp/v2/posts?per_page=3';
          var blog_post_url = 'https://blog.bimafy.com/wp-json/wp/v2/posts?per_page=3&tags[]=91';
           axios.get(blog_post_url)
            .then(response => {
              this.posts = response.data;
            })
    },
    data() {
        return {
            posts: []
        }
    },
    methods: {
        stripTags(html) {
            var sanitizeHtmlContnent =  sanitizeHtml(html, {
                allowedTags: []
            })
            // var readmore_length = html.indexOf('&hellip;') - 8;
            var readmore_length = 160;

            var subHtml = sanitizeHtmlContnent.substring(0, readmore_length);
            var readmore_dot = '...';
            if (subHtml) {
              return subHtml + readmore_dot;
            }else {
             return sanitizeHtmlContnent.substring(0, 300) + readmore_dot;
            }
        }
    }

}
</script>


